import React, { useEffect, useRef, useState } from 'react'
import { match } from 'ts-pattern'
import { Trans } from '@lingui/react/macro'

import styles from './index.module.scss'

import { useAiMusicGeneratorStoreFromZustand } from '@/pages/tad.ai/ai-music-generator/_store/createStore'
import { MarkDown } from '@/components/MD/markdown'


import { cls } from 'tagged-classnames-free';
const AiThinking: React.FC = () => {
  const {
    aiThinkingInfo,
    thinkingTime,
    aiThinkingContentExpand,
    updateAiThinkingContentExpand,
    thinkingTimeinterval,
  } = useAiMusicGeneratorStoreFromZustand()
  const { channelId, reasoningContent, lyricsContent } = aiThinkingInfo
  const { content: reasoningTxt } = reasoningContent
  const { content: lyricsTxt } = lyricsContent
  const hasContent = reasoningTxt || lyricsTxt
  const shouldShowContent = aiThinkingContentExpand && hasContent

  // 动画状态
  const [dotsCount, setDotsCount] = useState(1)

  // 滚动容器引用
  const scrollContainerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const interval = setInterval(() => {
      setDotsCount((prev) => (prev >= 3 ? 1 : prev + 1))
    }, 500)
    return () => clearInterval(interval)
  }, [])

  // 当内容更新时自动滚动到底部
  useEffect(() => {
    if (scrollContainerRef.current && reasoningTxt && shouldShowContent) {
      const container = scrollContainerRef.current
      // 使用 requestAnimationFrame 确保 DOM 更新后再滚动
      requestAnimationFrame(() => {
        container.scrollTop = container.scrollHeight
      })
    }
  }, [reasoningTxt, shouldShowContent])

  return (
    <div
      className={cls`
        border-f-border-secondary 
        mb-5 
        overflow-hidden
        rounded-lg
        border
        shadow-lg
      `}
    >
      {/* Header */}
      <div
        className={cls`
          flex 
          items-center 
          justify-between
          px-4 py-[10px]
        `}
      >
        <div className={cls`flex items-center justify-center`}>
          <span
            className={cls`text-f-text flex items-center text-sm font-medium`}
          >
            {match(!!thinkingTimeinterval)
              .with(true, () => (
                <div className='min-w-[70px]'>
                  <Trans>Thinking</Trans>
                  {'.'.repeat(dotsCount)}
                </div>
              ))
              .otherwise(() => (
                <span className='mr-1'>
                  <Trans>Thinking for</Trans>
                </span>
              ))}
            <span className='text-f-text-quaternary'>{` ${thinkingTime}s`}</span>
          </span>
        </div>

        <span
          onClick={() =>
            updateAiThinkingContentExpand(!aiThinkingContentExpand)
          }
          className={cls`
            i-com--up
            text-f-text-secondary 
            size-[18px] 
            cursor-pointer
            transition-transform
            ${aiThinkingContentExpand ? '' : 'rotate-180'}
          `}
        />
      </div>

      {/* Content */}
      {hasContent && (
        <div
          className={cls`
            space-y-4 
            overflow-hidden
            px-4
            transition-all
            duration-300
            ease-in-out
            ${shouldShowContent ? 'opacity-100' : 'max-h-0 opacity-0'}
          `}
          style={{
            paddingTop: shouldShowContent ? '10px' : '0',
            paddingBottom: shouldShowContent ? '10px' : '0',
          }}
        >
          <div
            className={cls`scrollbar ${styles['ai-thinking-content']} max-h-[450px] overflow-y-auto pr-1`}
            ref={scrollContainerRef}
          >
            {reasoningTxt && (
              <MarkDown
                className='text-f-text-quaternary text-sm'
                content={reasoningTxt}
              />
            )}
            {/* {lyricsTxt && (
              <MarkDown className='text-f-text text-sm' content={lyricsTxt} />
            )} */}
          </div>
        </div>
      )}
    </div>
  )
}

export default AiThinking
